import type { TFunction } from 'i18next'

import { createErrorMapRule } from '../utils/create-rule.ts'
import type { TranslationKey } from '../utils/types.ts'

type TooSmallRuleVariation = 'more-info'

export const tooSmallRule = (
  t: TFunction<'validation'>,
  context?: Record<string, unknown>,
  variation?: TooSmallRuleVariation
) =>
  createErrorMapRule('too_small', t, (issue, _) => {
    const translate = (
      key: TranslationKey,
      options?: Record<string, unknown>
    ) => t(key, options)
    const origin = issue.origin === 'int' ? 'number' : issue.origin
    if (origin === 'string' && variation) {
      return {
        message: translate(`string.${variation}.min` as TranslationKey, {
          ...issue,
          ...context,
          context: issue.inclusive ? 'inclusive' : 'exclusive',
          count: Number(issue.minimum),
        }),
      }
    }

    return {
      message: translate(`${origin}.min` as TranslationKey, {
        ...issue,
        ...context,
        context: issue.inclusive ? 'inclusive' : 'exclusive',
        count: Number(issue.minimum),
      }),
    }
  })
